module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "gl-form",
    staticClass: "md-area prepend-top-default append-bottom-default js-vue-markdown-field"
  }, [_c('markdown-header', {
    attrs: {
      "preview-markdown": _vm.previewMarkdown
    },
    on: {
      "toggle-markdown": _vm.toggleMarkdownPreview
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.previewMarkdown),
      expression: "!previewMarkdown"
    }],
    staticClass: "md-write-holder"
  }, [_c('div', {
    staticClass: "zen-backdrop"
  }, [_vm._t("textarea"), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('markdown-toolbar', {
    attrs: {
      "markdown-docs": _vm.markdownDocs
    }
  })], 2)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewMarkdown),
      expression: "previewMarkdown"
    }],
    staticClass: "md md-preview-holder md-preview"
  }, [_c('div', {
    ref: "markdown-preview",
    domProps: {
      "innerHTML": _vm._s(_vm.markdownPreview)
    }
  }), _vm._v(" "), (_vm.markdownPreviewLoading) ? _c('span', [_vm._v("\n      Loading...\n    ")]) : _vm._e()])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "zen-control zen-control-leave js-zen-leave",
    attrs: {
      "href": "#",
      "aria-label": "Enter zen mode"
    }
  }, [_c('i', {
    staticClass: "fa fa-compress",
    attrs: {
      "aria-hidden": "true"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d90f78e"}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue
// module id = ../../../node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-7d90f78e"}!../../../node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/markdown/field.vue
// module chunks = common_vue